/// <reference path='../../interfaces/interfaces.d.ts' />

'use strict';
enum HelpBoxViewState {
    Load,
    View,
    Close
}

class HelpBoxController {
    public static $inject = [
        '$rootScope',
        '$state',
        'User',
        'Employee',
    ];

    public title;
    public body;
    private ngIScope;
    private user;
    private employee;
    private helpBoxIndex;
    public visibility = 'hidden';
    public exists = false;
    private expanded = false;
    private helpTitle = [
        'TIP',
        'VIEW IMPORTANT UPCOMING DATES',
        'NEW WORKFLOW PROCESS FOR REQUESTS',
        'CONFIGURE YOUR ORGANISATION:',
        'CUSTOMISE AND EXPORT DATA',
        'VIEW ANY EMPLOYEE\'S HISTORY',
        'POWERFUL REPORTING FUNCTIONS',
        'MANAGE YOUR MEDICAL INSURANCE',
        'YOUR VIRTUAL FILING CABINET'
    ];
    private helpBody = [
        'Add events by type, customise who sees events, choose multiple views of personal, employee and team calendars.',
        'An overview of important upcoming dates like who is on leave, documents that are about to expire and upcoming birthdays and events.',
        'To upload your own templates for letters go to the Organisation section and click on the Processes tab.',
        'Set up your organisation however you wish by adding multiple offices, benefits and process. Edit any details at any time by clicking the pen icon.',
        'Access the powerful CSV export function by selecting Custom Export from the ellipsis menu.',
        'View an employee’s history quickly and easily by selecting History from the ellipsis menu.',
        'View turnover reports by Department and Year. Customise and export a CSV from a huge range of data points.',
        "Configure your organisation's medical insurance or request a quote for additional cover from preferred insurers.",
        'Filing cabinets are so 2010! Store and manage all of your documents online within the files section.'
    ];    

constructor(private $scope: ng.IScope, 
            private $state: ng.ui.IStateService, 
            private User: IUserService,
            private Employee: IEmpService
) {
        const that: any = this;
        this.ngIScope = $scope;
        this.user = User.getCurrentUser();

        $scope.$on('$pageWithHelpVisited', (event: any, index: any) => {
            this.helpBoxIndex = index;

            this.exists = true;
            this.title = this.helpTitle[index];
            this.body = this.helpBody[index];

            this.changeSavedVisitedState(index, HelpBoxViewState.Load);
        });

        $scope.$on('$stateChangeStart', (e: any, toState: any) => {
            this.exists = false;
            this.visibility = 'hidden';
            this.expanded = false;
        });
    }

    public helpIconClicked(): void {
        this.visibility = 'visible';
        this.changeSavedVisitedState(this.helpBoxIndex, HelpBoxViewState.View);
    }

    public clearIconClicked(): void {
        this.visibility = 'hidden';
        this.changeSavedVisitedState(this.helpBoxIndex, HelpBoxViewState.Close);
    }

    public toggleExpand(): void {
        if (this.expanded) {

            // already Expanded -> Hide
            this.expanded = false;
        } else {

            // already Hidden -> Expand
            this.expanded = true;
        }
    }
    
    private changeSavedVisitedState(index: any, viewState: HelpBoxViewState): void {
            if (!this.user.userData || !this.user.userData.id) {
                return;
            }

            this.Employee.loadEmployee(this.user.userData.id).then((response: Restangular.IResponse) => {
                this.employee = response;
                let list: any = this.employee.extra.help_boxes_visited;
                let listView: any = this.employee.extra.help_boxes_view;
                

                // create empty list if not defined
                if (list === undefined) {
                    list = [];
                }

                if (listView === undefined) {
                    listView = [];
                }

                // is the page being loaded
                if (viewState === HelpBoxViewState.Load) {

                    // have we seen this help box before
                    if (-1 === list.indexOf(index)) {
                        list.push(index);
                        this.employee.extra.help_boxes_visited = list;
                        this.visibility = 'visible';
                        this.Employee.updateHelpBoxViews(this.employee);
                        return;
                    } else if (listView.indexOf(index) >= 0) {

                        // has the user opened up the help box
                        this.visibility = 'visible';
                        return;
                    } else {

                        // nothing to do
                        return;
                    } 
                    
                } else if (viewState === HelpBoxViewState.Close && listView.indexOf(index) >= 0) {
                    
                    // has the user closed the help box
                    listView.splice(listView.indexOf(index), 1);
                    this.employee.extra.help_boxes_view = listView;
                    this.Employee.updateHelpBoxViews(this.employee);
                } else if (viewState === HelpBoxViewState.View && listView.indexOf(index) === -1) {
                    
                    // has the user opened the help box
                    listView.push(index);
                    this.employee.extra.help_boxes_view = listView;
                    this.Employee.updateHelpBoxViews(this.employee);
                }
            });
    }
}

angular.module('beneple.global')
    .controller('HelpBoxController', HelpBoxController);



// WEBPACK FOOTER //
// ./frontend/scripts/global/controllers/helpbox.controller.ts